@if (!isFeatured()) {
	<a
		routerLink="/open-days"
		class="inline-flex items-center justify-center w-full mb-3 rounded-md book-event-btn whitespace-nowrap"
	>
		Search {{ currentYear }} Open Days
	</a>
	<uc-write-review-btn
		[universityUrl]="uniSlug()"
		[universityId]="uniId()"
		[universityName]="uniName()"
		customStyles="block w-full secondary-button only-tab-focus !no-underline"
	/>
} @else if (featuredEvent()) {
	<uc-book-event-btn
		[externalUrl]="featuredEvent()?.external_url ?? ''"
		[uniId]="uniId()"
		[product]="product()"
		[eventType]="featuredEvent()?.type"
		[date]="featuredEvent()?.date"
		customStyles="w-full"
		componentName="Open Days Tab Profile Header"
		[ugSearchOrderPosition]="ugSearchOrderPosition()"
		[privacyPolicyUrl]="privacyPolicyUrl()"
		[uniName]="uniName()"
	/>
} @else {
	<uc-book-event-btn
		[externalUrl]="externalEventsUrl()"
		[uniId]="uniId()"
		[product]="product()"
		buttonText="Learn More About the Uni"
		customStyles="w-full mb-3"
		componentName="Open Days Tab Profile Header"
		[ugSearchOrderPosition]="ugSearchOrderPosition()"
		[privacyPolicyUrl]="privacyPolicyUrl()"
		[uniName]="uniName()"
	/>

	<uc-visit-website-btn
		[uniId]="uniId()"
		[source]="uniName()"
		sourceType="uni"
		[product]="product()"
		[externalUrl]="externalUrl()"
		customStyles="w-full secondary-button"
		componentName="Open Days tab"
		[ugSearchOrderPosition]="ugSearchOrderPosition()"
		[uniName]="uniName()"
	/>
}
